<!-- Gradent.vue -->
<template>
  <div>
    <!-- 上半部分的UI，不变 -->
    <div class="product-list-box" style="width: 70%; margin: 0 auto">
      <div class="product-list-item">
        <div id="maize" class="cursor" @click="changeType('maize')">
          <img src="../../assets/picture/yumiICON.png" alt="Icon" />
          <h5>Maize</h5>
        </div>
      </div>

      <div class="product-list-item">
        <div id="rice" class="cursor" @click="changeType('rice')">
          <img
            src="../../assets/picture/southeast-removebg-preview.png"
            alt="Icon"
          />
          <h5>Rice</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="cotton" class="cursor" @click="changeType('cotton')">
          <img src="../../assets/picture/mianhuaICON.png" alt="Icon" />
          <h5>Cotton</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="wheat" class="cursor" @click="changeType('wheat')">
          <img src="../../assets/picture/xiaomaiICON.png" alt="Icon" />
          <h5>Wheat</h5>
        </div>
      </div>
    </div>
    <!-- 动态加载的组件部分 -->
    <component :is="currentComponent" :parentMessage="message"></component>
  </div>
</template>

<script>
  import MaizeComponent from '../picCompoents/maizePic.vue';
  import cottonComponent from '../picCompoents/cottonPic.vue';
  import riceComponent from '../picCompoents/ricePic.vue';
  import wheatComponent from '../picCompoents/wheatPic.vue';
  
export default {
  name: "Heatmap",
  data() {
    return {
      // 动态组件
      currentComponent: "MaizeComponent",
      message: {
        type: 'heatmap'
      }
    };
  },
  components: {
    MaizeComponent,
    cottonComponent,
    riceComponent,
    wheatComponent
  },
  created() {
    
  },
  methods: {
    changeType(componentName) {
      if(componentName === 'maize') {
        this.currentComponent = "MaizeComponent"
        this.message = {
          type: "heatmap"
        }
      } else if (componentName === 'rice') {
        this.currentComponent = "riceComponent"
        this.message = {
          type: "heatmap"
        }
      } else if (componentName === 'cotton') {
        this.currentComponent = "cottonComponent"
        this.message = {
          type: "heatmap"
        }
      } else if (componentName === 'wheat') {
        this.currentComponent = "wheatComponent"
        this.message = {
          type: "heatmap"
        }
      }
    },
  },
};
</script>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.product-list-box {
  max-width: 900px;
}
</style>
